import { environmentBase } from './environment.base';

export const environment = {
  ...environmentBase,
  production: false,
  apiBaseUrl: 'https://nextup.pyxisapis.com/',
  timeout: 30000,
  debug: true,
  features: {
    ...environmentBase.features,
    enableAnalytics: false,
    enableLogging: true,
    enableCache: false
  },
  storage: {
    s3: {
      mediaBucketName: 'nextup-appmedia',
    },
    prefix: {
      attachment: 'attachment/',
    }
  }
};